//import React, { useEffect, useState, useContext } from "react";
//import React, { useEffect, useMemo, useState, useContext } from "react";
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
//import { Link } from "react-router-dom";
import "./Styles/clients.css";
//import { AuthLoginInfo } from "../AuthComponents/AuthLogin";
import Popup from "../Components/Popup";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
// import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArticleIcon from '@mui/icons-material/Article';
// import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import Switch from '@mui/material/Switch';
import CalculateIcon from '@mui/icons-material/Calculate';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import configData from "./config.json";
//import ReconnectingWebSocket from 'reconnecting-websocket';
//import io from "socket.io-client";
import { SocketDataContext } from "../App"; // or from separate provider file

const customId = "toast-main";
const isws = true;
// let socket = null;

// if (isws) {
//   socket = io(configData.SOCKET_URI, {
//     autoConnect: true,
//     reconnection: true,
//     reconnectionAttempts: Infinity,
//     reconnectionDelay: 1000,
//     reconnectionDelayMax: 5000,
//     timeout: 20000,
//     transports: ["websocket"],
//   });
// }

function Strategy() {
  //const ctx = useContext(AuthLoginInfo);
  //const [newOrderSubmitted, setNewOrderSubmitted] = useState(false);
  // const [isConnected, setIsConnected] = useState(socket.connected);  
  // const [logs, setLogs] = useState([]);  
  const { socket, ltpData, totalPnl, stratgPnl } = useContext(SocketDataContext);
  const [globalMessage, setGlobalMessage] = useState('');
  const [tableChanged, setTableChanged] = useState(true);  
  const [strategyData, setStrategyData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [buttonPopup, setButtonPopup] = useState(false);
  const [messageClassName, setMessageClassName] = useState('');
  //const [fieldChanged, setFieldChanged] = useState(false);
  const [buttonEditPopup, setEditButtonPopup] = useState(false);
  const [buttonViewPopup, setViewButtonPopup] = useState(false);
  const [buttonTradeViewPopup, setTradeViewButtonPopup] = useState(false);
  const [buttonVarsViewPopup, setVarsViewButtonPopup] = useState(false);
  const [totalLoss, setTotalLoss] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0); 
  const [popupShown, setPopupShown] = useState(false); 
  const [editFromCopy, setEditFromCopy] = useState(false);
  const [editPendingStrategy, setEditPendingStrategy] = useState(null); // which strategy we are trying to edit
  const [awaitingStop, setAwaitingStop] = useState(false);  
  const [updateDisabled, setUpdateDisabled] = useState(false);       
  const [warningMessage, setWarningMessage] = useState("");
  const [strategyVars, setStrategyVars] = useState([]);
  const [strategyVarsRecieved, setStrategyVarsRecieved] = useState(false);     
  const [logDetails, setLogDetails] = useState([{
    id:1,
    'strategy_name': 'S1',
    'descrp': '',
    'type': '',
    'created': ''
  }]);   
  const [tradeLogDetails, setTradeLogDetails] = useState([]); 
  const [strategyGlobalDetails, setStrategyGlobalDetails] = useState({
    name: "",
    indice: "NIFTY",
    order_type: "limit_buy",
    position_type: "buy",
    expiry: "current_wk",    
    entry_level: 0,
    qty: 0,              
    tlslx: 0,
    tlsly: 0,
    stoploss: 0,
    target: 0,
    stoploss_level: 0,
    trailing_sl: 0,
    target_level: 0,              
    strike: 0,
    risk_reward: 1,
    risk_amount: 0,
    risk_measure: 'points',                 
    sstatus: 0, 
    auto_sqoff_time: "15:20",
    repeatx_times: 5,
    total_loss: 0,
    total_profit: 0    
  });          
  //const [filterId, setFilterId] = useState("");
  const [strategyDetails, setStrategyDetails] = useState({});
  const [strategyAddDetails, setStrategyAddDetails] = useState({
    name: "",
    indice: "NIFTY",
    order_type: "limit_buy",
    expiry: "current_wk", 
    position_type:"buy",   
    entry_level: 0,
    qty: 0,
    tlslx: 0,                  
    tlsly: 0,                  
    stoploss: 0,
    target: 0,
    stoploss_level: 0,
    trailing_sl: 0,
    target_level: 0,              
    strike: 0,
    repeatx:0,
    repeat_times:0,
    wnt:0,
    wnt_pts:0,
    risk_reward: 1,
    risk_amount: 0,
    risk_measure: 'points',                 
    sstatus: 0, 
    positional: 0,
    repeatx_times: 0,
    retry:0,
    auto_sqoff_time: '15:20'
  });  

  const [filterOrders, setFilterOrders] = useState("");
  //#const [filterId, setFilterId] = useState("");
  const [filterActive, setFilterActive] = useState(1);

  // const [currentRecord, setRecord] = useState({});
  //const [lastField, setLastField] = useState('');
  //const [checkFileModified, setCheckFileModified] = useState(true);  
  const toastId = React.useRef(null);
  // const [ltpData, setLtpData] = useState({});
  // const [livePnl, setLivePnl] = useState(0);
  // const [totalPnl, setTotalPnl] = useState(0);  
  // const [stratgPnl, setStratgPnl] = useState({});
  // const {globalLTP, setGlobalLTP} = useContext(LTPContext);
  const globalSettingName = 'global-setting'

  const notify = (toast_mess, ntype, position, autoclose) => {
    //if(! toast.isActive(toastId.current)) {
      var auto_close = false;
      if(autoclose === true) auto_close = 2000; else auto_close = false;
      if(ntype === 'success') {
        toastId.current = toast.success(toast_mess, {
          position: position,
          theme: "dark",
          toastId: customId,
          autoClose : auto_close,
          newestOnTop: true
        });
      } else if (ntype === 'error') {
        toastId.current = toast.error(toast_mess, {
          position: position,
          theme: "dark",
          toastId: customId,
          autoClose : auto_close,
          newestOnTop: true
        });        
      } else {
        toastId.current = toast.success(toast_mess, {
          position: position,
          theme: "dark",
          toastId: customId,
          autoClose : auto_close,
          newestOnTop: true
        });
      }
    //}
  }



  useEffect(() => {
      setTableChanged(false);
      axios
      .get(configData.BACKEND_URL+"/strategy", { withCredentials: true })
      .then((res) => {
        if (res.data !== null) {
          setStrategyData(res.data);
          setFilteredData(res.data);
        }
      });

      FetchGlobalSettings();

  }, [tableChanged]);


  useEffect(() => {
    if (!isws || !socket) return
  
    // message handler
    const handleMessage = (payload) => {
      let data
      try {
        // Depending on server, payload may already be an object or a JSON string
        data = typeof payload === 'string' ? JSON.parse(payload) : payload
      } catch (err) {
        console.error('Invalid message payload', payload, err)
        return
      }
  
      if (data.event === 'param_change' && data.action === 'reload') {
        setTableChanged(true)
      } 
      if (data.event === 'strategy_snapshot') {
        const snapshot = JSON.parse(data.snapshot)
        setStrategyVars(snapshot)
        console.log('Strategy Snapshot Received:', snapshot)
        setVarsViewButtonPopup(true)
      }

      if (data.event === 'strategy_snapshot_single') {
        const snapshot = JSON.parse(data.snapshot)
        setStrategyVars(snapshot)
        setStrategyVarsRecieved(true);
        console.log('Strategy Snapshot Single Received:', snapshot)
      }

      if(totalPnl < 0 && totalPnl < -totalLoss && totalLoss !==0 && popupShown === false) {
        setGlobalMessage('Total Loss for the day reached: -'+totalLoss);
        setMessageClassName('redbold');
        setPopupShown(true); 
      }
      if(totalPnl > 0 && totalPnl > totalProfit && totalProfit !==0 && popupShown === false ) {
        setGlobalMessage('Total profit for the day reached: '+totalProfit);
        setMessageClassName('greenbold');
        setPopupShown(true);   
      }     
      if(totalPnl > -totalLoss && totalPnl < totalProfit && popupShown === true) {
        setGlobalMessage('');
        setMessageClassName('');
        setPopupShown(false);
      }
   
    }
  
    const handleConnect = () => {
      console.log('Socket connected')
    }
  
    const handleError = (err) => {
      console.log('Socket error', err)
    }
  
    const handleDisconnect = (reason) => {
      console.log('Socket disconnected. Reason:', reason)
    }
  
    // Wire up Socket.IO events
    socket.on('message', handleMessage)      // server should emit 'message', payload
    socket.on('connect', handleConnect)
    socket.on('connect_error', handleError)
    socket.on('disconnect', handleDisconnect)
  
    // Cleanup to avoid duplicate handlers on re-renders
    return () => {
      socket.off('message', handleMessage)
      socket.off('connect', handleConnect)
      socket.off('connect_error', handleError)
      socket.off('disconnect', handleDisconnect)
    }
  }, [socket, popupShown, totalPnl, totalLoss, totalProfit, strategyVarsRecieved])


  // useEffect(() => {
  //   if (!editPendingStrategy || !strategyVarsRecieved) return;
  //   if (!strategyVars) return;
  
  //   const sstatusNum = Number(editPendingStrategy.sstatus); // from DB row / table
  //   const statusText = String(strategyVars.status || "").toLowerCase(); // from snapshot
  //   const isRunning = statusText === "running";
  //   const isOffState = strategyVars.start_trading === false; // OFF when false
  
  //   console.log("Edit flow snapshot:", {
  //     editPendingStrategy,
  //     sstatusNum,
  //     statusText,
  //     start_trading: strategyVars.start_trading,
  //     awaitingStop,
  //   });
  
  //   // 1) ON + Running: block editing
  //   // if (sstatusNum === 1 && isRunning) {
  //   //   setGlobalMessage(
  //   //     "Strategy is currently Running. You cannot update it while it is running."
  //   //   );
  //   //   setEditPendingStrategy(null);
  //   //   setStrategyVarsRecieved(false);
  //   //   setAwaitingStop(false);
  //   //   return;
  //   // }
  
  //   // 2) ON but not Running and we haven't sent stop yet → send stop once
  //   if (sstatusNum === 1 && !isRunning && !awaitingStop) {
  //     setGlobalMessage("Stopping strategy for update...");
  
  //     const event_data = {
  //       event: "strategy_stop",
  //       id: editPendingStrategy.id,
  //       message: "Strategy Updated",
  //     };
  
  //     if (isws === true && socket && socket.connected) {
  //       socket.emit("client_message", event_data);
  //     }
  
  //     setAwaitingStop(true);
  //     setStrategyVarsRecieved(false);
  
  //     // Ask again for snapshot after stop
  //     strategySnapshotGet(editPendingStrategy);
  //     return;
  //   }
  
  //   // 3) After stop: when runtime says OFF (start_trading === false), open editor
  //   if (isOffState || !isRunning) {
  //     setWarningMessage("");
  //     setStrategyDetails(editPendingStrategy);
  //     setEditButtonPopup(true);
  
  //     setEditPendingStrategy(null);
  //     setAwaitingStop(false);
  //     setStrategyVarsRecieved(false);
  //   }
  // }, [
  //   editPendingStrategy,
  //   strategyVarsRecieved,
  //   strategyVars,
  //   awaitingStop,
  //   socket,
  // ]);
  
  const handleEditClick = (client) => {
    const row = JSON.parse(JSON.stringify(client));
  
    console.log("handleEditClick", row);
    setWarningMessage("");
    setEditButtonPopup(false);
    setStrategyVarsRecieved(false);
    setAwaitingStop(false);
  
    const sstatusNum = Number(row.sstatus);
  
    // If already OFF, just open the editor directly
    if (sstatusNum === 0) {
      setStrategyDetails(row);
      setEditButtonPopup(true);
      return;
    } else if (sstatusNum === 1 && row.status === "Running") {
      setStrategyDetails(row);
      setEditButtonPopup(true);           
      return;   
    } else if (sstatusNum === 1 && row.status === "WNT_ACTIVE") {
      setStrategyDetails(row);
      setEditButtonPopup(true);           
      return;   
    } else if (sstatusNum === 1 && row.status === "WaitingReEntry") {
      setStrategyDetails(row);
      setEditButtonPopup(true);           
      return;   
    } else if (sstatusNum === 1 && row.status === "WaitingRepeat") {
      setStrategyDetails(row);
      setEditButtonPopup(true);           
      return;   
    } else if(sstatusNum === 1 && row.status === "Waiting") {
      const event_data = {
        event: "strategy_stop",
        id: row.id,
        message: "Strategy Updated",
      };
  
      if (isws === true && socket && socket.connected) {
        socket.emit("client_message", event_data);
        console.log("sent stop event from client");
      } 
      setStrategyDetails(row);
      setEditButtonPopup(true);           
      return;    
    }
      // For ON strategies, go through the snapshot flow
    //setEditPendingStrategy(row);
    //strategySnapshotGet(row); // asks backend for runtime snapshot
  };
  
  const handleSearchChange = (newFilteredData) => {
    console.log('newFilteredData',newFilteredData);
    setFilteredData(newFilteredData);

    // const dataFiltered = newFilteredData
    //   ?.filter((val) => {
    //     console.log('status: ',status);
    //     console.log('searchInput',searchInput);
    //     if (val.name.includes(searchInput))
    //     {
    //       return val;
    //     }
    //   });
    //   console.log('newFilteredData strategyDataFiltered ',dataFiltered);
    //   setFilteredData(dataFiltered);

  };

  // console.log("c", strategyData);
  // console.log("f", filteredData);

  const FetchGlobalSettings = () => {
    axios.post(configData.BACKEND_URL+"/get-setting", 
      {
        globalSettingName,
      }, 
      { withCredentials: true })
      .then((res) => {
        if (res.data !== null) {
          //console.log(res.data);
          setStrategyGlobalDetails(res.data);
          if(res.data.total_loss) { setTotalLoss(res.data.total_loss); }
          if(res.data.total_profit) { setTotalProfit(res.data.total_profit); }
        }
      });  

  };

  const UpdateStrategy = () => {
    //getFormattedCurrentDateTime('Edit 1');
    //var event_data = {'event':'strategy_update', 'id': strategyDetails.id, 'data': strategyDetails, 'message':'Strategy Updated'}
    // ws.send(JSON.stringify(event_data)) 
    //console.log(strategyDetails)
    // if (isws === true && socket && socket.connected) {
    //   socket.emit('client_message', event_data);
      // setTableChanged(true);
      // setEditButtonPopup(false); 
      
      // setStrategyDetails({
      //   id: '',
      //   name: "",
      //   indice: "NIFTY",
      //   order_type: "limit_buy",
      //   expiry: "current_wk",
      //   position_type:"buy",   
      //   entry_level: 0,
      //   qty: 0,
      //   tlslx: 0,            
      //   tlsly: 0,            
      //   stoploss: 0,
      //   target: 0,
      //   stoploss_level: 0,
      //   trailing_sl: 0,
      //   target_level: 0,                                     
      //   strike: 0,
      //   repeatx:0,
      //   repeat_times:0,
      //   risk_reward: 1,
      //   risk_amount: 0,
      //   risk_measure: 'points',
      //   sstatus: 0,
      //   positional: 0,
      //   repeatx_times: 0,
      //   retry: 0,
      //   auto_sqoff_time: '15:20'             
      // });      

    //}   
    // get current status of the strategy before update. If status is ON then turn OFF first before update. Make sure nifty is not ru
    // var event_data = {'event':'strategy_update', 'id': strategyDetails.id, 'message':'Strategy Current Status Fetched'}
    // ws.send(JSON.stringify(event_data)) 
    // strategySnapshotGet(strategyDetails);
    // if(strategyVarsRecieved === true && strategyVars.id === strategyDetails.id && strategyVars.sstatus === 1 && strategyVars.status === "Running") {
    //   setWarningMessage("Strategy is Currently Running. Can't Update While Running.");
    //   setStrategyVarsRecieved(false);
    //   return false;
    // } else if (strategyVarsRecieved === true && strategyVars.id === strategyDetails.id && strategyVars.sstatus === 1) {
    //   setWarningMessage("Strategy Stopped for Update.");
    //   var event_data = {'event':'strategy_stop', 'id': strategyDetails.id, 'message':'Strategy Updated'}
    //   ws.send(JSON.stringify(event_data));       
    //   setStrategyVarsRecieved(false);
    // } 
    // strategySnapshotGet(strategyDetails);
    // if (strategyVarsRecieved === true && strategyVars.id === strategyDetails.id && strategyVars.sstatus === 0) {
    //   setWarningMessage("Strategy Successfully Stopped.");
    // }

    axios
      .post(configData.BACKEND_URL+"/updatestrategy",
        {
          strategyDetails,
        },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.data === "success") {
          setStrategyDetails({
            id: '',
            name: "",
            indice: "NIFTY",
            order_type: "limit_buy",
            expiry: "current_wk",
            position_type:"buy",   
            entry_level: 0,
            qty: 0,
            tlslx: 0,            
            tlsly: 0,            
            stoploss: 0,
            target: 0,
            stoploss_level: 0,
            trailing_sl: 0,
            target_level: 0,                                     
            strike: 0,
            repeatx:0,
            repeat_times:0,
            risk_reward: 1,
            risk_amount: 0,
            risk_measure: 'points',
            sstatus: 0,
            positional: 0,
            repeatx_times: 0,
            retry: 0,
            auto_sqoff_time: '15:20'             
          });
          setTableChanged(true);
          setEditButtonPopup(false); 
          var event_data = {'event':'params_reload', 'message':'Strategy Updated'}
          //var event_data = {'event':'strategy_update', 'data': strategyDetails, 'message':'Strategy Updated'}
          if (isws === true && socket && socket.connected) {
            socket.emit('client_message', event_data)
          }                    
        }
      });
  };

  const RoundedQuantity = (num, indice) => {
      var temp_qty = 0;
      if(indice === "NIFTY") {
        temp_qty = Math.round(num / 65)  * 65;
        if(temp_qty < 65) temp_qty = 65;
      } else if(indice === "BANKNIFTY") {
        temp_qty = Math.round(num / 30)  * 30;
        if(temp_qty < 30) temp_qty = 30;
      } else if(indice === "FINNIFTY") {
        temp_qty = Math.round(num / 65)  * 65;  
        if(temp_qty < 65) temp_qty = 65;
      } else if(indice === "SENSEX") {
        temp_qty = Math.round(num / 20)  * 20;  
        if(temp_qty < 20) temp_qty = 20;             
      } else if(indice === "BANKEX") {
        temp_qty = Math.round(num / 30)  * 30;  
        if(temp_qty < 30) temp_qty = 30;         
      }
      return temp_qty;
  };

  const setEntryLevel = () => {
    //var entry_level = 0;
    // setStrategyAddDetails({...strategyGlobalDetails});
    setStrategyAddDetails({
      ...strategyGlobalDetails,
      entry_level: Math.round(ltpData.NIFTY)
    });
    console.log('setEntryLevel', Math.round(ltpData.NIFTY));
    // setEntryLevelOnChange(strategyAddDetails.indice)
    // if(strategyAddDetails.indice === "BANKEX" && ltpData.BANKEX > 0) {
    //   entry_level = Math.round(ltpData.BANKEX);  
    //   setEntryLevelOnChange(strategyAddDetails.indice)    
    // } else if(strategyAddDetails.indice === "BANKNIFTY" && ltpData.BANKNIFTY > 0) {
    //   entry_level = Math.round(ltpData.BANKNIFTY);
    // } else if(strategyAddDetails.indice === "NIFTY" && ltpData.NIFTY > 0) {
    //   entry_level = Math.round(ltpData.NIFTY);
    // } else if(strategyAddDetails.indice === "FINNIFTY" && ltpData.FINNIFTY > 0) {
    //   entry_level = Math.round(ltpData.FINNIFTY);
    // } else if(strategyAddDetails.indice === "SENSEX" && ltpData.SENSEX > 0) {
    //   entry_level = Math.round(ltpData.SENSEX);
    // }
    // strategyAddDetails.entry_level = entry_level;
    // console.log('setEnetryLevel', entry_level);
    // setStrategyAddDetails({
    //   ...strategyAddDetails,
    //   entry_level: entry_level
    // });    
    
  };

  const setEntryLevelOnChange = (nindice) => {
    var entry_level = 0;
    if(nindice === "BANKNIFTY" && ltpData.BANKNIFTY > 0) {
      entry_level = Math.round(ltpData.BANKNIFTY);
    } else if(nindice === "NIFTY" && ltpData.NIFTY > 0) {
      entry_level = Math.round(ltpData.NIFTY);
    } else if(nindice === "FINNIFTY" && ltpData.FINNIFTY > 0) {
      entry_level = Math.round(ltpData.FINNIFTY);
    } else if(nindice === "SENSEX" && ltpData.SENSEX > 0) {
      entry_level = Math.round(ltpData.SENSEX);
    }
    strategyAddDetails.entry_level = entry_level;
    console.log('setEntryLevelOnChange', entry_level);
  };

  const CalcParamsAll = () => {
    console.log(strategyDetails);

    // if(fieldChanged === false) {
    //   return 
    // }

    if(strategyDetails.status === "Running") {
      return;
    }

    if(strategyDetails.wnt === 1) {
      ResetLevels();
    }    

    if(strategyDetails.stoploss_level === 0 || strategyDetails.stoploss_level === "0") {  
      console.log('stoploss_level === 0');  
      strategyDetails.stoploss_level = (strategyDetails.order_type === 'limit_sell' || strategyDetails.order_type === 'trigger_sell' ) ? (parseFloat(strategyDetails.entry_level) + parseFloat(strategyDetails.stoploss)):(parseFloat(strategyDetails.entry_level) - parseFloat(strategyDetails.stoploss)).toFixed(2)
    } else {
      console.log('stoploss_level === 0 else');        
      strategyDetails.stoploss = (strategyDetails.order_type === 'limit_sell' || strategyDetails.order_type === 'trigger_sell' ) ? (parseFloat(strategyDetails.stoploss_level) - parseFloat(strategyDetails.entry_level)):(parseFloat(strategyDetails.entry_level) - parseFloat(strategyDetails.stoploss_level)).toFixed(2)
    }
    if(strategyDetails.target_level === 0 || strategyDetails.target_level === "0") {  
      console.log('target_level === 0');           
      strategyDetails.target_level = (strategyDetails.order_type === 'limit_sell' || strategyDetails.order_type === 'trigger_sell' ) ? (parseFloat(strategyDetails.entry_level) - parseFloat(strategyDetails.target)):(parseFloat(strategyDetails.entry_level) + parseFloat(strategyDetails.target)).toFixed(2)                                              
    } else {
      console.log('target_level === 0 else');        
      strategyDetails.target = (strategyDetails.order_type === 'limit_sell' || strategyDetails.order_type === 'trigger_sell' ) ? (parseFloat(strategyDetails.entry_level) - parseFloat(strategyDetails.target_level)):(parseFloat(strategyDetails.target_level) - parseFloat(strategyDetails.entry_level)).toFixed(2)                                              
    }

    if(strategyDetails.order_type === 'limit_buy' && strategyDetails.wnt === 1) {
      strategyDetails.stoploss_level = (parseFloat(strategyDetails.entry_level) - parseFloat(strategyDetails.stoploss) + parseFloat(strategyDetails.wnt_pts)).toFixed(2)
      strategyDetails.target_level = (parseFloat(strategyDetails.entry_level) + parseFloat(strategyDetails.target) + parseFloat(strategyDetails.wnt_pts)).toFixed(2)
    }
  
    if(strategyDetails.order_type === 'limit_sell' && strategyDetails.wnt === 1) {
      strategyDetails.stoploss_level = (parseFloat(strategyDetails.entry_level) + parseFloat(strategyDetails.stoploss) - parseFloat(strategyDetails.wnt_pts)).toFixed(2)
      strategyDetails.target_level = (parseFloat(strategyDetails.entry_level) - parseFloat(strategyDetails.target) - parseFloat(strategyDetails.wnt_pts)).toFixed(2)
    }    

    if(strategyDetails.status === "Waiting" || strategyDetails.status === "Off") {
      strategyDetails.qty = RoundedQuantity(strategyDetails.risk_amount / strategyDetails.stoploss, strategyDetails.indice);
      strategyDetails.risk_reward = (strategyDetails.target / strategyDetails.stoploss).toFixed(2); 
    }

    strategyDetails.trailing_sl = strategyDetails.stoploss_level   
 
    console.log(strategyDetails)   
    setStrategyDetails({...strategyDetails});
};

const ResetLevels = () => {
  console.log(strategyDetails);
  if(strategyDetails.status !== "Running") {
    strategyDetails.stoploss_level = 0;
    strategyDetails.trailing_sl = 0;
    strategyDetails.target_level = 0;
  } else {
    if(strategyDetails.order_type === 'limit_buy' && strategyDetails.stoploss_level > strategyDetails.trailing_sl) {
      strategyDetails.trailing_sl = strategyDetails.stoploss_level
    } else if(strategyDetails.order_type === 'limit_sell' && strategyDetails.stoploss_level < strategyDetails.trailing_sl) {
      strategyDetails.trailing_sl = strategyDetails.stoploss_level
    } else if(strategyDetails.order_type === 'trigger_buy' && strategyDetails.stoploss_level > strategyDetails.trailing_sl) {
      strategyDetails.trailing_sl = strategyDetails.stoploss_level
    } else if(strategyDetails.order_type === 'trigger_sell' && strategyDetails.stoploss_level < strategyDetails.trailing_sl) {
      strategyDetails.trailing_sl = strategyDetails.stoploss_level
    }      
    console.log('Strategy Running. Levels not reset traling sl set as stoploss level.');
  }
  console.log(strategyDetails)   
  setStrategyDetails({...strategyDetails});
};

const ResetLevelsAdd = () => {
  console.log(strategyAddDetails);
  strategyAddDetails.stoploss_level = 0;
  strategyAddDetails.trailing_sl = 0;
  strategyAddDetails.target_level = 0;
  console.log(strategyAddDetails)   
  setStrategyAddDetails({...strategyAddDetails});
};

const viewLog = (row) => {
  console.log('viewLog',row);
  var sid = row.id;
  console.log('viewlog sid',sid);
  axios.get(configData.BACKEND_URL+"/strategylog?sid="+sid, { withCredentials: true }
  ).then((res) => {
    //#if (res.data === "success") {
      const logs = res.data;
      console.log(logs);
      setLogDetails(logs);
      setViewButtonPopup(true);
    //}
});
  
  // setViewButtonPopup(JSON.parse(JSON.stringify(client))); 

  // var v_qty = strategyAddDetails.risk_amount / strategyAddDetails.stoploss;
  // v_qty = (RoundedQuantity(v_qty, strategyAddDetails.indice))
  // var v_risk_amount = strategyAddDetails.stoploss * v_qty;     
  // var v_stoploss = v_risk_amount / v_qty;
  // var risk_reward = (strategyAddDetails.target / v_stoploss)   
  // var target = (risk_reward * v_stoploss)    
  // var stoploss_level = (strategyAddDetails.order_type === 'limit_sell' || strategyAddDetails.order_type === 'trigger_sell' ) ? (parseInt(strategyAddDetails.entry_level) + parseInt(v_stoploss)):(parseInt(strategyAddDetails.entry_level) - parseInt(v_stoploss))
  // var target_level = (strategyAddDetails.order_type === 'limit_sell' || strategyAddDetails.order_type === 'trigger_sell' ) ? (parseInt(strategyAddDetails.entry_level) - parseInt(target)):(parseInt(strategyAddDetails.entry_level) + parseInt(target))                                              
  // risk_reward = parseFloat(risk_reward).toFixed(2); 

  // setStrategyAddDetails({
  //   ...strategyAddDetails,
  //   qty: v_qty,
  //   risk_amount: v_risk_amount,  
  //   stoploss: v_stoploss,   
  //   stoploss_level: stoploss_level,
  //   target_level: target_level,
  //   target: target,
  //   risk_reward: risk_reward
  // });
     
  // console.log(strategyAddDetails)    
  //if(lastField !== param) setLastField(param)
};

// const viewSnapshot = (row) => {
//   console.log('TradeLog',row);
//   var sid = row.id;
//   console.log('tradelog sid',sid);
//   axios.get(configData.BACKEND_URL+"/strategytradelog?sid="+sid, { withCredentials: true }
//   ).then((res) => {
//     //#if (res.data === "success") {
//       const trades = res.data;
//       console.log(trades);
//       setTradeLogDetails(trades);
//       setTradeViewButtonPopup(true);
//     //}
// })};

const viewTrades = (row) => {
  console.log('TradeLog',row);
  var sid = row.id;
  console.log('tradelog sid',sid);
  axios.get(configData.BACKEND_URL+"/strategytradelog?sid="+sid, { withCredentials: true }
  ).then((res) => {
    //#if (res.data === "success") {
      const trades = res.data;
      console.log(trades);
      setTradeLogDetails(trades);
      setTradeViewButtonPopup(true);
    //}
})};

const deleteStrategy = (row) => {
  var sid = row.id;
  if (window.confirm("Are you sure you want to delete this strategy?")) {
	  var event_data = {'event':'delete_strategy','id':sid, 'message':'Delete Strategy'}
  	  // if(isws === true) {
    	//   	ws.send(JSON.stringify(event_data))
  	  // }
    if (isws === true && socket && socket.connected) {
      socket.emit('client_message', event_data)
    }      
  	setTableChanged(true);
  } 
};

const terminateStrategy = (row) => {
  //console.log('terminateStrategy',row);
  var sid = row.id;
  //console.log('terminateStrategy sid',sid);
  if (window.confirm("Are you sure you want to terminate this strategy?")) {
	  var event_data = {'event':'terminate_strategy','id':sid, 'message':'Terminate Strategy'}
  	  // if(isws === true) {
    	//   	ws.send(JSON.stringify(event_data))
  	  // }
    if (isws === true && socket && socket.connected) {
      socket.emit('client_message', event_data)
    }      
  	setTableChanged(true);
  } 
};

const strategySnapshot = (row) => {
  console.log('Strategy Snapshot: ',row);
  var sid = row.id;
	var event_data = {'event':'strategy_snapshot_sent','id':sid, 'message':'Strategy Snapshot Requested'}
  // if(isws === true) {
  //   ws.send(JSON.stringify(event_data))
  // }
  if (isws === true && socket && socket.connected) {
    socket.emit('client_message', event_data)
  } 
};

const strategySnapshotGet = (row) => {
  console.log('Strategy Snapshot: ',row);
  var sid = row.id;
	var event_data = {'event':'strategy_snapshot_get','id':sid, 'message':'Strategy Snapshot Requested'}
  // if(isws === true) {
  //   ws.send(JSON.stringify(event_data))
  // }
  if (isws === true && socket && socket.connected) {
    socket.emit('client_message', event_data)
  } 
};

// const sendGlobalReload = () => {
//   console.log("Global Params Reloading")
//   var event_data = {'event':'params_reload', 'message':'Params Reloading'}
//   if(isws === true) {
//     ws.send(JSON.stringify(event_data))
//   }
//   setTableChanged(true);
// };

const sendParamReload = () => {
  console.log("Params Reloading")
  var event_data = {'event':'params_reload', 'message':'Params Reloading'}
  // if(isws === true) {
  //   ws.send(JSON.stringify(event_data))
  // }
  if (isws === true && socket && socket.connected) {
    socket.emit('client_message', event_data)
  }   
  setTableChanged(true);
};

// const copyStrategy = (row) => {
//     console.log('copyStrategy',row);
//     axios.post(configData.BACKEND_URL+"/copystrategy", { 'strategyDetails': row, }, { withCredentials: true })
//     .then((res) => {
//       if (res.data === "success") {
//         setNewOrderSubmitted(true);
//         setEditButtonPopup(true); 
//         setStrategyDetails(JSON.parse(JSON.stringify(row)));
//       }
//     });
// };

const copyAddStrategy = (row) => {
  console.log('copyStrategy updated:',row);
  //var sid = row.id; 

  var thisStrategy = JSON.parse(JSON.stringify(row));

  // Extract current name
  let baseName = thisStrategy.name;

  // Regex to detect existing " - Copy" or " - CopyX"
  const copyRegex = /( - Copy)(\d+)?$/;

  if (copyRegex.test(baseName)) {
    // Already a Copy — increment the number
    baseName = baseName.replace(copyRegex, (match, copyText, number) => {
      const nextNumber = number ? parseInt(number) + 1 : 2;
      return ` - Copy${nextNumber}`;
    });
  } else {
    // First copy
    baseName = baseName + " - Copy";
  }

  setStrategyAddDetails({
    name: baseName,
    indice: thisStrategy.indice,
    order_type: thisStrategy.order_type,
    position_type: thisStrategy.position_type,
    entry_level: thisStrategy.entry_level,
    qty: thisStrategy.qty,
    tlslx: thisStrategy.tlslx,
    tlsly: thisStrategy.tlsly,
    stoploss: thisStrategy.stoploss,
    target: thisStrategy.target,
    stoploss_level: thisStrategy.stoploss_level,
    trailing_sl: thisStrategy.trailing_sl,
    target_level: thisStrategy.target_level,
    strike: thisStrategy.strike,
    risk_reward: thisStrategy.risk_reward,
    risk_amount: thisStrategy.risk_amount,
    repeatx: thisStrategy.repeatx,
    repeatx_times: thisStrategy.repeatx_times,
    retry: thisStrategy.retry,
    wnt: thisStrategy.wnt,
    wnt_pts: thisStrategy.wnt_pts,
    expiry: thisStrategy.expiry,
    positional: thisStrategy.positional,
    auto_sqoff_time: thisStrategy.auto_sqoff_time,
    sstatus: 0
  }); 
  setButtonPopup(true); 
  // setStrategyAddDetails(JSON.parse(JSON.stringify(row)));
  // setButtonPopup(true); 

  // axios.post(configData.BACKEND_URL+"/copystrategy", { 'strategyDetails': row, }, { withCredentials: true })
  // .then((res) => {
  //   if (res.data === "success") {
  //     axios
  //     .get(configData.BACKEND_URL+"/strategy", { withCredentials: true })
  //     .then((res) => {
  //       if (res.data !== null) {
  //         setEditFromCopy(true);
  //         setStrategyData(res.data);
  //         setFilteredData(res.data);
  //         setEditButtonPopup(true); 
  //         setStrategyDetails(JSON.parse(JSON.stringify(row)));
  //       }
  //     });
  //   }
  // });
};

const CalcParamsAddAll = () => {
  console.log(strategyAddDetails);

  if(strategyAddDetails.wnt === 1) {
    ResetLevelsAdd();
  }   

  if(strategyAddDetails.stoploss_level === 0 || strategyAddDetails.stoploss_level === "0") {  
    console.log('stoploss_level === 0');  
    strategyAddDetails.stoploss_level = (strategyAddDetails.order_type === 'limit_sell' || strategyAddDetails.order_type === 'trigger_sell' ) ? (parseFloat(strategyAddDetails.entry_level) + parseFloat(strategyAddDetails.stoploss)):(parseFloat(strategyAddDetails.entry_level) - parseFloat(strategyAddDetails.stoploss)).toFixed(2)
  } else {
    console.log('stoploss_level === 0 else');        
    strategyAddDetails.stoploss = (strategyAddDetails.order_type === 'limit_sell' || strategyAddDetails.order_type === 'trigger_sell' ) ? (parseFloat(strategyAddDetails.stoploss_level) - parseFloat(strategyAddDetails.entry_level)):(parseFloat(strategyAddDetails.entry_level) - parseFloat(strategyAddDetails.stoploss_level)).toFixed(2)
  }
  if(strategyAddDetails.target_level === 0 || strategyAddDetails.target_level === "0") {  
    console.log('target_level === 0');           
    strategyAddDetails.target_level = (strategyAddDetails.order_type === 'limit_sell' || strategyAddDetails.order_type === 'trigger_sell' ) ? (parseFloat(strategyAddDetails.entry_level) - parseFloat(strategyAddDetails.target)):(parseFloat(strategyAddDetails.entry_level) + parseFloat(strategyAddDetails.target)).toFixed(2)                                              
  } else {
    console.log('target_level === 0 else');        
    strategyAddDetails.target = (strategyAddDetails.order_type === 'limit_sell' || strategyAddDetails.order_type === 'trigger_sell' ) ? (parseFloat(strategyAddDetails.entry_level) - parseFloat(strategyAddDetails.target_level)):(parseFloat(strategyAddDetails.target_level) - parseFloat(strategyAddDetails.entry_level)).toFixed(2)                                              
  }

  if(strategyAddDetails.order_type === 'limit_buy' && strategyAddDetails.wnt === 1) {
    strategyAddDetails.stoploss_level = (parseFloat(strategyAddDetails.entry_level) - parseFloat(strategyAddDetails.stoploss) + parseFloat(strategyAddDetails.wnt_pts)).toFixed(2)
    strategyAddDetails.target_level = (parseFloat(strategyAddDetails.entry_level) + parseFloat(strategyAddDetails.target) + parseFloat(strategyAddDetails.wnt_pts)).toFixed(2)
  }

  if(strategyAddDetails.order_type === 'limit_sell' && strategyAddDetails.wnt === 1) {
    strategyAddDetails.stoploss_level = (parseFloat(strategyAddDetails.entry_level) + parseFloat(strategyAddDetails.stoploss) - parseFloat(strategyAddDetails.wnt_pts)).toFixed(2)
    strategyAddDetails.target_level = (parseFloat(strategyAddDetails.entry_level) - parseFloat(strategyAddDetails.target) - parseFloat(strategyAddDetails.wnt_pts)).toFixed(2)   
  }

  strategyAddDetails.qty = RoundedQuantity(strategyAddDetails.risk_amount / strategyAddDetails.stoploss, strategyAddDetails.indice);  
  strategyAddDetails.risk_reward = (strategyAddDetails.target / strategyAddDetails.stoploss).toFixed(2); 
  strategyAddDetails.trailing_sl = strategyAddDetails.stoploss_level

  console.log(strategyAddDetails)   
  setStrategyAddDetails({...strategyAddDetails});
};

// const CalcParamsAddAll = () => {
//   var v_qty = strategyAddDetails.risk_amount / strategyAddDetails.stoploss;
//   v_qty = (RoundedQuantity(v_qty, strategyAddDetails.indice))
//   var v_risk_amount = strategyAddDetails.stoploss * v_qty;     
//   var v_stoploss = v_risk_amount / v_qty;
//   var risk_reward = (strategyAddDetails.target / v_stoploss)   
//   var target = (risk_reward * v_stoploss)    
  
//   if(strategyAddDetails.stoploss_level === 0) {
//     var stoploss_level = (strategyAddDetails.order_type === 'limit_sell' || strategyAddDetails.order_type === 'trigger_sell' ) ? (parseInt(strategyAddDetails.entry_level) + parseInt(v_stoploss)):(parseInt(strategyAddDetails.entry_level) - parseInt(v_stoploss))
//   }

//   if(strategyAddDetails.target_level === 0) {  
//     var target_level = (strategyAddDetails.order_type === 'limit_sell' || strategyAddDetails.order_type === 'trigger_sell' ) ? (parseInt(strategyAddDetails.entry_level) - parseInt(target)):(parseInt(strategyAddDetails.entry_level) + parseInt(target))                                              
//   }

//   risk_reward = parseFloat(risk_reward).toFixed(2); 

//   setStrategyAddDetails({
//     ...strategyAddDetails,
//     qty: v_qty,
//     risk_amount: v_risk_amount,  
//     stoploss: v_stoploss,   
//     stoploss_level: stoploss_level,
//     target_level: target_level,
//     target: target,
//     risk_reward: risk_reward
//   });

//   console.log(strategyAddDetails)    
//   //if(lastField !== param) setLastField(param)
// };

const handleRepeatAddChange = (row, isChecked) => {
  if(isChecked.target.checked === true && (row.order_type === 'trigger_buy' || row.order_type === 'trigger_sell')) {
    console.log(row);
    notify('Repeat option available with LIMIT BUY or LIMIT SELL. Please change order type to LIMIT BUY or LIMIT SELL', 'error');
    return false;
  }
  console.log('isChecked handleRepeatAddChange',isChecked.target.checked);
    if(isChecked.target.checked) {
      row.repeatx = 1;
      row.retry = 0;
    } else {
      row.repeatx = 0;      
    }
    setStrategyAddDetails({
      ...strategyAddDetails,
      repeatx: row.repeatx,
      retry: row.retry,
      tlslx: 0,
      tlsly: 0
    });       
};

const handleRetryAddChange = (row, isChecked) => {
  if(isChecked.target.checked === true) {
    //console.log(row);
    //notify('Repeat option available with LIMIT BUY or LIMIT SELL. Please change order type to LIMIT BUY or LIMIT SELL', 'error');
    //return false;
  }
  console.log('isChecked handleRetryAddChange',isChecked.target.checked);
    if(isChecked.target.checked) {
      row.retry = 1;
      row.repeatx = 0;
    } else {
      row.retry = 0;      
    }
    setStrategyAddDetails({
      ...strategyAddDetails,
      repeatx: row.repeatx,
      retry: row.retry,
      tlslx: 0,
      tlsly: 0
    });       
};

const handleTLSLXChange = (e) => {
  const newTlslx = e.target.value;

  setStrategyAddDetails((prev) => {
    const updated = { ...prev, tlslx: newTlslx };
    // If tlsly > tlslx, reset tlsly and warn user
    if (parseFloat(updated.tlsly) > parseFloat(newTlslx)) {
      setWarningMessage("TLSLY cannot be greater than TLSLX. Resetting to match TLSLX.");
      updated.tlsly = newTlslx;
    } else {
      setWarningMessage("");
    }
    return updated;
  });
};

const handleTLSLYChange = (e) => {
  const newTlsly = e.target.value;

  setStrategyAddDetails((prev) => {
    const updated = { ...prev, tlsly: newTlsly };
    if (parseFloat(newTlsly) > parseFloat(prev.tlslx)) {
      setWarningMessage("TLSLY cannot be greater than TLSLX. Resetting to match TLSLX.");
      updated.tlsly = prev.tlslx;
    } else {
      setWarningMessage("");
    }
    return updated;
  });
};

const handleTLSLXEditChange = (e) => {
  const newTlslx = e.target.value;

  if(strategyDetails.status === 'Running' || strategyDetails.status === 'WaitingReEntry' || strategyDetails.status === 'WaitingRepeat' || strategyDetails.status === 'WNT_ACTIVE' ) {
    setWarningMessage('Cannot Update TLSLX for Running strategy.');
    setMessageClassName('redbold');
    return false;
  }

  setStrategyDetails((prev) => {
    const updated = { ...prev, tlslx: newTlslx };
    // If tlsly > tlslx, reset tlsly and warn user
    if (parseFloat(updated.tlsly) > parseFloat(newTlslx)) {
      setWarningMessage("TLSLY cannot be greater than TLSLX. Resetting to match TLSLX.");
      updated.tlsly = newTlslx;
    } else {
      setWarningMessage("");
    }
    return updated;
  });
};

const handleTLSLYEditChange = (e) => {
  const newTlsly = e.target.value;

  if(strategyDetails.status === 'Running' || strategyDetails.status === 'WaitingReEntry' || strategyDetails.status === 'WaitingRepeat' || strategyDetails.status === 'WNT_ACTIVE' ) {
    setWarningMessage('Cannot Update TLSLY for Running strategy.');
    setMessageClassName('redbold');
    return false;
  }

  setStrategyDetails((prev) => {
    const updated = { ...prev, tlsly: newTlsly };
    if (parseFloat(newTlsly) > parseFloat(prev.tlslx)) {
      setWarningMessage("TLSLY cannot be greater than TLSLX. Resetting to match TLSLX.");
      updated.tlsly = prev.tlslx;
    } else {
      setWarningMessage("");
    }
    return updated;
  });
};

const handleCarryChange = (row, isChecked) => {
    if(isChecked.target.checked) {
      row.positional = 1;
    } else {
      row.positional = 0;      
    }
    setStrategyDetails({
      ...strategyDetails,
      positional: row.positional,
    });       
};


const handleCarryAddChange = (row, isChecked) => {
  if(isChecked.target.checked) {
    row.positional = 1;
  } else {
    row.positional = 0;      
  }
  setStrategyAddDetails({
    ...strategyAddDetails,
    positional: row.positional,
  });       
};


const handleWntAddChange = (row, isChecked) => {
  if(isChecked.target.checked === true && (row.order_type === 'trigger_buy' || row.order_type === 'trigger_sell')) {
    console.log(row);
    notify('Repeat option available with LIMIT BUY or LIMIT SELL. Please change order type to LIMIT BUY or LIMIT SELL', 'error');
    return false;
  }

  console.log('isChecked handleWntAddChange',isChecked.target.checked);
    if(isChecked.target.checked) {
      row.wnt = 1;
    } else {
      row.wnt = 0;
      row.wnt_pts = 0;      
    }
    setStrategyAddDetails({
      ...strategyAddDetails,
      wnt: row.wnt,
      wnt_pts: row.wnt_pts
    });       
};

const handleWntChange = (row, isChecked) => {
  if(isChecked.target.checked === true && (row.order_type === 'trigger_buy' || row.order_type === 'trigger_sell')) {
    console.log(row);
    notify('Repeat option available with LIMIT BUY or LIMIT SELL. Please change order type to LIMIT BUY or LIMIT SELL', 'error');
    return false;
  }

  if(row.status === 'Running') {
    setWarningMessage('Cannot Update WNT option for Running strategy.');
    return false;
  }

  console.log('isChecked handleWntAddChange',isChecked.target.checked);
    if(isChecked.target.checked) {
      row.wnt = 1;
    } else {
      row.wnt = 0;
      row.wnt_pts = 0;      
    }
    setStrategyDetails({
      ...strategyDetails,
      wnt: row.wnt,
      wnt_pts: row.wnt_pts
    });       
};

const handleRepeatChange = (row, isChecked) => {
  if(isChecked.target.checked === true && (row.order_type === 'trigger_buy' || row.order_type === 'trigger_sell')) {
    console.log(row);
    notify('Repeat option available with LIMIT BUY or LIMIT SELL. Please change order type to LIMIT BUY or LIMIT SELL', 'error');
    return false;
  }  

  if(isChecked.target.checked === true && row.retry === 1) {
    console.log(row);
    notify('Repeat option available with LIMIT BUY or LIMIT SELL. Please change order type to LIMIT BUY or LIMIT SELL', 'error');
    return false;
  }

  if(row.status === 'Running') {
    setWarningMessage('Cannot Update Repeat option for Running strategy.');
    return false;
  }

  console.log('isChecked handleRepeatChange',isChecked.target.checked);
    if(isChecked.target.checked) {
      row.repeatx = 1;
      row.retry = 0;
    } else {
      row.repeatx = 0;      
    }
    setStrategyDetails({
      ...strategyDetails,
      repeatx: row.repeatx,
      retry: row.retry,
      tlslx: 0,
      tlsly: 0
    });       
};

const handleRetryChange = (row, isChecked) => {
  if(isChecked.target.checked === true) {
    //console.log(row);
    //notify('Repeat option available with LIMIT BUY or LIMIT SELL. Please change order type to LIMIT BUY or LIMIT SELL', 'error');
    //return false;
  }  

  if(row.status === 'Running') {
    setWarningMessage('Cannot Update Re-Entry option for Running strategy.');
    return false;
  }

  console.log('isChecked handleRetryChange',isChecked.target.checked);
    if(isChecked.target.checked) {
      row.retry = 1;
      row.repeatx = 0;
    } else {
      row.retry = 0;      
    }
    setStrategyDetails({
      ...strategyDetails,
      retry: row.retry,
      repeatx: row.repeatx,      
      tlslx: 0,
      tlsly: 0
    });       
};

const setRepeatOff = (row) => {
    row.repeatx = 0;
    return true;
};

// const setRetryOff = (row) => {
//     row.retry = 0;
//     return true;
// };

const getFormattedCurrentDateTime = (mess) => {
  const now = new Date();
  const formatted = now.getFullYear() + '-' +
  String(now.getMonth() + 1).padStart(2, '0') + '-' +
  String(now.getDate()).padStart(2, '0') + ' ' +
  String(now.getHours()).padStart(2, '0') + ':' +
  String(now.getMinutes()).padStart(2, '0') + ':' +
  String(now.getSeconds()).padStart(2, '0');
  console.log(mess,formatted);
}


const setWntOff = (row) => {
  row.wnt = 0;
  row.wnt_pts = 0;
  return true;
};
  const handleChange = (row, isChecked) => {
    console.log('isChecked',isChecked.target.checked);
    // if(row.sstatus === 1) 
    //   row.sstatus = 0;
    // else
    //   row.sstatus = 1;
    // if(isChecked.target.checked) {
    //   row.sstatus = 1;
    // } else {
    //   row.sstatus = 0;      
    // } 

    //setRecord(JSON.parse(JSON.stringify({id:client.id,sstatus:(client.sstatus===1?0:1)})));

    // console.log('before ',currentRecord);
    // setRecord(JSON.parse(JSON.stringify({id:row.id,sstatus:row.sstatus})));
    // // console.log(JSON.parse(JSON.stringify(row)));
    // console.log('after ',currentRecord);
    console.log(row); 
    // console.log(currentRecord);

    if(row.sstatus === 1 && row.status === 'Running') {
      setGlobalMessage('Cannot Stop Running Strategy.');
      return;
    } else if(row.sstatus === 1 && row.status === 'WaitingRepeat') {
      setGlobalMessage('Cannot Stop WaitingRepeat Strategy.');
      return;
    } else if(row.sstatus === 1 && row.status === 'WaitingReEntry') {
      setGlobalMessage('Cannot Stop WaitingReEntry Strategy.');
      return;
    } else if(row.sstatus === 1 && row.status === 'WNT_ACTIVE') {
      setGlobalMessage('Cannot Stop WNT_ACTIVE Strategy.');
      return;              
    } else {
      setGlobalMessage('');
    }

    axios.post(configData.BACKEND_URL+"/updatestrategystatus",
        {
          'strategyDetails': row,
        },
        { withCredentials: true }
      ).then((res) => {
        if (res.data === "success") {
          setTableChanged(true); 
          var event_data = {'event':'params_reload', 'message':'Strategy Status Updated'}
          // ws.send(JSON.stringify(event_data))
          if (isws === true && socket && socket.connected) {
            socket.emit('client_message', event_data)
          }                                   
          // axios
          // .get(configData.BACKEND_URL+"/strategy", { withCredentials: true })
          // .then((res) => {
          //   if (res.data != null) {
          //     setStrategyData(res.data);
          //     setFilteredData(res.data);
          //   }
          // });
        }
      });
  };
  
  const handleMslcChange = (row, isChecked) => {
    console.log('isChecked',isChecked.target.checked);
    if(row.retry === 1 ) {
      setGlobalMessage('Cannot move sl to cost.');
      return;
    } else if(row.repeatx === 1 ) {
      setGlobalMessage('Cannot move sl to cost.');
      return;
    } else if(row.tlslx > 0) {
      setGlobalMessage('Cannot move sl to cost.');
      return;
    } else {
      setGlobalMessage('');
    }

    axios.post(configData.BACKEND_URL+"/updatestrategymslc",
        {
          'strategyDetails': row,
        },
        { withCredentials: true }
      ).then((res) => {
        if (res.data === "success") {
          setTableChanged(true); 
          var event_data = {'event':'params_reload', 'message':'Strategy Status Updated'}
          // ws.send(JSON.stringify(event_data))
          if (isws === true && socket && socket.connected) {
            socket.emit('client_message', event_data)
          }                                   
        }
      });
  };
  

  const StrategyTable = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 30;
    const totalStrategy = filteredData.length;
    const computedStrategy = filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      (currentPage - 1) * itemsPerPage + itemsPerPage
    );
    const computedStrategyLength = computedStrategy.length;

    return (
      <>
        {" "}

        <div className="tableResultsWrap">
          {" "}
          <div className="resultsSpan">
            Showing <font className="resultsBold"> {computedStrategyLength} </font> of <font className="resultsBold"> {totalStrategy} </font> results
          </div>
          <Pagination total={totalStrategy} itemsPerPage={itemsPerPage} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
        </div>
        <div className="orderNav">
              <ul>
                <li className={`${filterActive === 1 ? "active" : ""}`} onClick={() => { setFilterOrders(""); setFilterActive(1); }}>All</li>
                <li className={`${filterActive === 2 ? "active" : ""}`} onClick={() => { setFilterOrders("Waiting"); setFilterActive(2); }}>Waiting</li>
                <li className={`${filterActive === 3 ? "active" : ""}`} onClick={() => { setFilterOrders("Running"); setFilterActive(3); }}>Running</li>                
                <li className={`${filterActive === 4 ? "active" : ""}`} onClick={() => { setFilterOrders("Error"); setFilterActive(4); }}>Error</li>                
                <li className={`${filterActive === 5 ? "active" : ""}`} onClick={() => { setFilterOrders("SLHIT"); setFilterActive(5); }}>SLHIT</li>
                <li className={`${filterActive === 6 ? "active" : ""}`} onClick={() => { setFilterOrders("TGHIT"); setFilterActive(6); }}>TGHIT </li>                
              </ul>
            </div>
            
        <table>
          <thead>
            <tr>
              <th><font className="maincolor">&nbsp;&nbsp;&nbsp;&nbsp;#</font></th>
              <th></th>                               
              <th>Name</th>
              <th>Indice</th>
              <th>Carry</th>
              <th>OrderType</th>
              <th>Pos</th>              
              <th>Entry</th>
              <th>SLLVL</th>
              <th>TLSLV</th>
              <th>TGLVL</th>                            
              <th>Qty</th>
              <th>TLSLX</th>              
              <th>TLSLY</th>              
              <th>SL</th>   
              <th>TG</th>                          
              <th>Strike</th>              
              <th>RR</th>
              <th>Risk</th>
              <th>Rep</th>
              <th>Ret</th>              
              <th>WPts</th>
              <th className="st_pnl">PNL</th>              
			  <th className="center">MSLC</th>
              <th className="st_pnl">Status</th>
              <th></th>                                                            
            </tr>
          </thead>
          <tbody>
            {computedStrategy.map((client, i) => {
              return (
                <tr key={i} className={client.status.toLowerCase()}>
                  <td>
                    <div className={(client.inactive===1?'hide':'')}>
                    {/* <input type="checkbox" checked={(client.sstatus===1?true:false)} onChange={(event) => { setRecord(JSON.parse(JSON.stringify({id:client.id,sstatus:(client.sstatus===1?0:1)})));handleChange(client, event)}} /> */}
					<Switch size="small" checked={(client.sstatus===1?true:false)} onClick={(event) => { handleChange(client, event)}} />
                    </div>
                  </td>
                  <td>{client.status}</td>                   
                  <td className="clickable" onClick={() => viewTrades(JSON.parse(JSON.stringify(client)))}>{client.name} {client.repeatx > 0 || client.retry > 0? <span>({client.repeat_times})</span> : ''}</td>
                  <td>{client.indice}</td>
                  <td>{client.positional}</td>                  
                  <td>{client.order_type}</td>
                  <td>{client.position_type}</td>
                  <td>{client.entry_level}</td>
                  <td>{client.stoploss_level}</td>
                  <td>{client.trailing_sl}</td>                  
                  <td>{client.target_level}</td>                                    
                  <td>{client.qty}</td>                  
                  <td>{client.tlslx}</td>
                  <td>{client.tlsly}</td>
                  <td>{client.stoploss}</td>
                  <td>{client.target}</td>                                    
                  <td>{client.strike}</td>
                  <td>{client.risk_reward}</td>
                  <td className="clickable" onClick={() => strategySnapshot(JSON.parse(JSON.stringify(client)))}>{client.risk_amount}</td> 
                  <td>{client.repeatx_times}</td> 
                  <td>{client.retry}</td> 
                  <td>{client.wnt_pts}</td>                   
                  <td className={"st_pnl "+client.name.toUpperCase()}>
                    <div>
                    {client.sstatus === 0 ? <span>{client.pnl}</span> : ''}
                    {(stratgPnl && stratgPnl[client.id] > 0 && client.sstatus === 1) ? <span className="greenbold">{stratgPnl[client.id]}</span> : <span></span> }
                    {(stratgPnl && stratgPnl[client.id] < 0 && client.sstatus === 1) ? <span className="redbold">{stratgPnl[client.id]}</span> : <span></span> }        
                    </div>
                    </td>  
                    <td>
                    <div className={(client.tlslx > 0 || client.retry ===1 || client.repeatx ===1 || client.tlslx===1?'center hide':'center')}>
					            <Switch size="small" checked={(client.mslc===1?true:false)} onClick={(event) => { handleMslcChange(client, event)}} />
                    </div>
                  </td>
                  <td className="st_pnl">{(client.sstatus===1?'ON':'OFF')}</td>
                  <td className="maincolor">
                    <button title="Squareoff and Terminate Strategy" className="terminateButton" onClick={() => terminateStrategy(JSON.parse(JSON.stringify(client)))}> <PowerSettingsNewIcon /></button>
                    <button title="Copy Strategy" className="editOrderButton" onClick={() => copyAddStrategy(JSON.parse(JSON.stringify(client)))}> <ContentCopyIcon /></button>
                    {/* <button title="Edit Strategy" className="editOrderButton" onClick={() => { setEditButtonPopup(true); setStrategyDetails(JSON.parse(JSON.stringify(client))); }}> <EditRoundedIcon /> </button> */}
                    <button title="Edit Strategy" className="editOrderButton" onClick={() => handleEditClick(client)}> <EditRoundedIcon /> </button>
                    <button title="Strategy Log" className="editOrderButton" onClick={() => viewLog(JSON.parse(JSON.stringify(client)))}> <ReadMoreRoundedIcon /></button>
                    <button title="Strategy Trade Log" className="editOrderButton" onClick={() => viewTrades(JSON.parse(JSON.stringify(client)))}> <ArticleIcon /></button>
                    <button title="Delete" className="terminateButton" onClick={() => deleteStrategy(JSON.parse(JSON.stringify(client)))}> <DeleteOutlineIcon /></button>

                  </td>                                                                                                           
                </tr>
              );
            })}
          </tbody>
       
        </table>

       

        
      </>
    );
  };

  const AddStrategy = () => {
    // const [strategyAddDetails, setStrategyAddDetails] = useState({
    //   name: "",
    //   indice: "NIFTY",
    //   order_type: "",
    //   entry_level: "",
    //   qty: 0,
    //   stoploss: 0,
    //   target: 0,  
    //   stoploss_level: 0,
    //   target_level: 0,             
    //   strike: 0,
    //   risk_reward: 1,
    //   risk_amount: "",
    //   risk_measure: 'points',      
    //   sstatus: 0,      
    // });

    const addNewStrategy = () => { 
        //console.log(strategyAddDetails);
        getFormattedCurrentDateTime('Add 1');
        axios
        .post(configData.BACKEND_URL+"/newstrategy",
          {
            strategyAddDetails,
          },
          { withCredentials: true } 
        )
        .then((res) => {
          getFormattedCurrentDateTime('Add 2');
          if (res.data === "success") {
            setStrategyAddDetails({
              name: "",
              indice: "NIFTY",
              order_type: "limit_buy",
              position_type: "buy",
              entry_level: 0,
              qty: 0,              
              stoploss: 0,
              target: 0,
              tlslx: 0,
              tlsly: 0,
              stoploss_level: 0,
              target_level: 0,              
              strike: 0,
              repeatx: 0,
              repeat_times: 0,
              wnt: 0,
              wnt_pts: 0,              
              risk_reward: 1,
              risk_amount: 0,
              risk_measure: 'points',                 
              sstatus: 0,
              positional: 0,
              repeatx_times: 0,
              retry: 0,
              auto_sqoff_time: '15:20'                            
            });
            //getFormattedCurrentDateTime('Add 3');            
            setTableChanged(true);
            //getFormattedCurrentDateTime('Add 4');
            setButtonPopup(false);
            var event_data = {'event':'params_reload', 'message':'New Strategy Added'}
            // ws.send(JSON.stringify(event_data))
            if (isws === true && socket && socket.connected) {
              socket.emit('client_message', event_data)
            }             
            //getFormattedCurrentDateTime('Add 5 WS');            
          }
        });
    };


    return ( 
      <Popup trigger={buttonPopup} setTrigger={setButtonPopup}>
        <div className="popupWrap">
          <div className="productsSummary">
            <h3 className="productSummaryLeft">Add New Strategy</h3>
          </div>

          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                <div className="input-group input-group-20">
                  <label>Strategy Name</label>
                  <input
                    type="text"
                    placeholder=""
                    className="orderDetailsInput"
                    value={strategyAddDetails.name}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        name: e.target.value,
                      })]
                    }
                    required="required"
                  />
                  </div>
                  <div className="input-group input-group-20">
                  <label>Indice</label>
                  <select
                    className="orderDetailsSelect"
                    placeholder="Indice"
                    value={strategyAddDetails.indice}
                    onChange={(e) => {
                      const newIndice = e.target.value;
                      const currentExpiry = strategyAddDetails.expiry || "";
                      let newExpiry = currentExpiry;
                
                      if (newIndice === "BANKNIFTY") {
                        // BANKNIFTY → force monthly expiry
                        if (!currentExpiry || currentExpiry.includes("_wk")) {
                          newExpiry = "current_month";
                        }
                      } else {
                        // NIFTY / SENSEX → allow weekly expiry
                        if (!currentExpiry || currentExpiry.trim() === "") {
                          newExpiry = "current_wk";
                        }
                      }
                      setEntryLevelOnChange(newIndice);                      
                      setStrategyAddDetails({
                        ...strategyAddDetails,
                        indice: newIndice,
                        expiry: newExpiry,
                      });

                    }}
                    required
                  >
                    <option value="NIFTY">NIFTY</option>
                    <option value="BANKNIFTY">BANKNIFTY</option>
                    <option value="SENSEX">SENSEX</option>
                  </select>
                </div>
                

                
                  <div className="input-group input-group-20">               
                  <label>Position Type</label>
                  <select
                    className="orderDetailsSelect"
                    placeholder=""
                    value={strategyAddDetails.position_type}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        position_type: e.target.value,
                      })]
                    }
                    required="required"
                  >
                    <option value="buy">BUY</option>
                    <option value="sell">SELL</option>
                  </select>
                  </div>   
                  <div className="input-group input-group-20">
                  <label>AutoSqf Time</label>
                  <input
                    type="text"
                    placeholder=""
                    className="orderDetailsInput"
                    value={strategyAddDetails.auto_sqoff_time}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        auto_sqoff_time: e.target.value,
                      })]
                    }
                    required="required"
                  />
                  </div>                   
                  <div className="input-group input-group-20-last">
                  <label>Status</label>
                  <select
                    className="orderDetailsSelect"
                    placeholder=""
                    value={strategyAddDetails.sstatus}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        sstatus: e.target.value,
                      })]
                    }
                    required="required"
                  >
                    <option value="0">OFF</option>
                    <option value="1">ON</option>                                                                                                                                           
                  </select>
                  </div>
                                                  
                  <div className="input-group input-group-25">  
                  <label>Order Type</label>                
                  <select
                    className="orderDetailsSelect"
                    placeholder=""
                    value={strategyAddDetails.order_type}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        order_type: e.target.value,
                      })]
                    }
                    required="required"
                  >
                    <option value="limit_buy">LIMIT_BUY</option>
                    <option value="limit_sell">LIMIT_SELL</option>
                    <option value="trigger_buy">TRIGGER_BUY</option>
                    <option value="trigger_sell">TRIGGER_SELL</option>                    
                  </select> 
                  </div>
                  <div className="input-group input-group-33">
                  <label>Expiry</label>
                  <select
                    className="orderDetailsSelect"
                    placeholder="Expiry To Trade"
                    value={strategyAddDetails.expiry}
                    onChange={(e) =>
                      setStrategyAddDetails({
                        ...strategyAddDetails,
                        expiry: e.target.value,
                      })
                    }
                    required
                  >
                    {[
                      { value: "current_wk", label: "WEEKLY-CURRENT" },
                      { value: "next_wk", label: "WEEKLY-NEXT" },
                      { value: "far_next_wk", label: "WEEKLY-FAR NEXT" },
                      { value: "current_month", label: "MONTHLY-CURRENT" },
                      { value: "next_month", label: "MONTHLY-NEXT" },
                      { value: "far_next_month", label: "MONTHLY-FAR NEXT" },
                    ]
                      .filter(
                        (opt) =>
                          strategyAddDetails.indice !== "BANKNIFTY" ||
                          !opt.value.includes("_wk")
                      )
                      .map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                  </select>
                </div>                

                <div className="input-group input-group-15">                
                <label>WN Pts</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyAddDetails.wnt_pts}
                  onChange={(e) => 
                    [setStrategyAddDetails({
                      ...strategyAddDetails,
                      wnt_pts: e.target.value,
                    })]
                  }
                  required="required"
                />     
                </div> 
                <div className="input-group input-group-15">
                  <label>WNT</label>
                  <Switch disabled={(strategyAddDetails.order_type==="trigger_buy" || strategyAddDetails.order_type==="trigger_sell") ?setWntOff(strategyAddDetails):false} checked={(strategyAddDetails.wnt===1?true:false)} onClick={(event) => { handleWntAddChange(strategyAddDetails, event)}} />
                </div>                 
                <div className="input-group input-group-10">
                  <label>Positional</label> 
                  <Switch checked={(strategyAddDetails.positional===1?true:false)} onClick={(event) => { handleCarryAddChange(strategyAddDetails, event)}} />
                </div>                                     
                <div className="input-group input-group-20">  
                  <label>Entry Level</label>                                                     
                  <input
                    type="text"
                    placeholder=""
                    className="orderDetailsInput"
                    value={strategyAddDetails.entry_level}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        entry_level: e.target.value,
                      })]
                    }
                    required="required"
                  />  
                </div>
                <div className="input-group input-group-10">                
                <label>TLSLX</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyAddDetails.tlslx}
                  onChange={handleTLSLXChange}                  
                  // onChange={(e) => 
                  //   [setStrategyAddDetails({
                  //     ...strategyAddDetails,
                  //     tlslx: e.target.value,
                  //   })]
                  // }
                  required="required"
                />     
                </div> 
                <div className="input-group input-group-10">                
                <label>TLSLY</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyAddDetails.tlsly}
                  onChange={handleTLSLYChange}                  
                  // onChange={(e) => 
                  //   [setStrategyAddDetails({
                  //     ...strategyAddDetails,
                  //     tlsly: e.target.value,
                  //   })]
                  // }
                  required="required"
                />     
                </div>                                  
                <div className="input-group input-group-15">                
                <label>Stoploss</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyAddDetails.stoploss}
                  onChange={(e) => 
                    [setStrategyAddDetails({
                      ...strategyAddDetails,
                      stoploss: e.target.value,
                    })]
                  }
                  required="required"
                />     
                </div>           
                <div className="input-group input-group-15">    
                <label>Target</label>            
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyAddDetails.target}
                  onChange={(e) =>
                    [setStrategyAddDetails({
                      ...strategyAddDetails,
                      target: e.target.value,                      
                    })]
                  }
                  required="required"
                />                   
                </div>
                <div className="input-group input-group-20">                 
                  <label>Strike</label>
                  <select
                    className="orderDetailsSelect"
                    placeholder=""
                    value={strategyAddDetails.strike}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        strike: e.target.value,
                      })]
                    }
                    required="required"
                  >
                  <option value="-20">OTM-20</option>                     
                  <option value="-19">OTM-19</option>                     
                  <option value="-18">OTM-18</option>                     
                  <option value="-17">OTM-17</option>                     
                  <option value="-16">OTM-16</option>                     
                  <option value="-15">OTM-15</option>                     
                  <option value="-14">OTM-14</option>                     
                  <option value="-13">OTM-13</option>                     
                  <option value="-12">OTM-12</option>                     
                  <option value="-11">OTM-11</option>                     
                  <option value="-10">OTM-10</option>                     
                  <option value="-9">OTM-9</option>  
                  <option value="-8">OTM-8</option>  
                  <option value="-7">OTM-7</option>  
                  <option value="-6">OTM-6</option>  
                  <option value="-5">OTM-5</option>                   
                  <option value="-4">OTM-4</option>  
                  <option value="-3">OTM-3</option>  
                  <option value="-2">OTM-2</option>                                                              
                  <option value="-1">OTM-1</option>                    
                  <option value="0">ATM</option>
                  <option value="1">ITM+1</option>
                  <option value="2">ITM+2</option>
                  <option value="3">ITM+3</option>
                  <option value="4">ITM+4</option> 
                  <option value="5">ITM+5</option>                                        
                  <option value="6">ITM+6</option>                                        
                  <option value="7">ITM+7</option>                                        
                  <option value="8">ITM+8</option>                                        
                  <option value="9">ITM+9</option>                                        
                  <option value="10">ITM+10</option>                                      
                  <option value="11">ITM+11</option>                                      
                  <option value="12">ITM+12</option>                                      
                  <option value="13">ITM+13</option>                                      
                  <option value="14">ITM+14</option>                                      
                  <option value="15">ITM+15</option>                                      
                  <option value="16">ITM+16</option>                                      
                  <option value="17">ITM+17</option>                                      
                  <option value="18">ITM+18</option>                                      
                  <option value="19">ITM+19</option>                                      
                  <option value="20">ITM+20</option>                                      
                  </select>
                  </div>

                <div className="input-group input-group-5">
                  <label>ReEntry</label>
                  <Switch checked={(strategyAddDetails.retry===1?true:false)} onClick={(event) => { handleRetryAddChange(strategyAddDetails, event)}} />
                   
                </div>                   
                <div className="input-group input-group-15">                
                <label>SL Level</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyAddDetails.stoploss_level}
                  onChange={(e) => 
                    [setStrategyAddDetails({
                      ...strategyAddDetails,
                      stoploss_level: e.target.value,
                    })]
                  }
                  required="required"
                />     
                </div>
                <div className="input-group input-group-15">                
                <label>TLSL Level</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyAddDetails.trailing_sl}
                  onChange={(e) => 
                    setStrategyDetails({
                      ...strategyAddDetails,
                      trailing_sl: e.target.value,
                    })
                  }
                  required="required"
                />     
                </div>                 
                <div className="input-group input-group-15">    
                <label>TargetLevel</label>            
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyAddDetails.target_level}
                  onChange={(e) =>
                    [setStrategyAddDetails({
                      ...strategyAddDetails,
                      target_level: e.target.value,
                    })]
                  }
                  required="required"
                />                   
                </div>                  
                  <div className="input-group input-group-15">
                  <label>Qty</label>
                  <input
                    type="text"
                    placeholder=""
                    className="orderDetailsInput"
                    value={strategyAddDetails.qty}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        qty: e.target.value,
                      })]
                    }
                    required="required"
                  />                    

                </div> 
                <div className="input-group input-group-10">
                  <label>R:Amt</label>
                  <input
                    type="text"
                    placeholder=""
                    className="orderDetailsInput"
                    value={strategyAddDetails.risk_amount}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        risk_amount: e.target.value,
                      })]
                    }
                    required="required"
                  />
                  
                </div>                                                 
                  <div className="input-group input-group-10">
                  <label>R:R</label>
                  <input
                    type="text"
                    placeholder=""
                    className="orderDetailsInput"
                    value={strategyAddDetails.risk_reward}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        risk_reward: e.target.value
                      })]
                    }
                    required="required"
                  />                    
                </div>
                  <div className="input-group input-group-10">
                  <label>RepX</label>
                  <input
                    type="text"
                    placeholder="Repeat Times"
                    className="orderDetailsInput"
                    value={strategyAddDetails.repeatx_times}
                    onChange={(e) =>
                      [setStrategyAddDetails({
                        ...strategyAddDetails,
                        repeatx_times: e.target.value
                      })]
                    }
                    required="required"
                  />                    
                </div>                
                <div className="input-group input-group-10
                ">
                  <label>Repeat</label>
                  <Switch disabled={(strategyAddDetails.order_type==="trigger_buy" || strategyAddDetails.order_type==="trigger_sell") ?setRepeatOff(strategyAddDetails):false} checked={(strategyAddDetails.repeatx===1?true:false)} onClick={(event) => { handleRepeatAddChange(strategyAddDetails, event)}} />
                   
                </div> 
                               
              </div>
            </div>
          </div>
          <div>{warningMessage && (
            <p style={{ color: "red", fontSize: "0.9em", textAlign: 'center' }}>{warningMessage}</p>
            )}</div>
          <div className="submitWrap">
            <div className="submitNewOrder">
            <div className="input-group input-group-33">  
              <button
                className="calculateBtn"
                onClick={(e) => CalcParamsAddAll()}>
                <CalculateIcon />               
                <span className="addOrderText">Calculate</span>
              </button>   
              </div>   
              <div className="input-group input-group-33">  
              <button
                className="calculateBtn"
                onClick={(e) => ResetLevelsAdd()}>
                <CalculateIcon />               
                <span className="addOrderText">Reset Levels</span>
              </button>   
              </div>                          
              <div className="input-group input-group-33"> 
                           
              <button
                className="submitNewOrderBtn"
                onClick={() => {
                  ResetLevelsAdd();
                  CalcParamsAddAll();
                  addNewStrategy();
                }}>
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
              </div>
            </div>
          </div>
        </div>
      </Popup>
    );




  };

  return (
    <div className="bodyWrap" key="strategy-list">
      <div className="contentOrderWrap clientsTableWrap">
        <div className="leftSide">
          <table>
          <tbody>
          <tr>
          <td width="30%" className="noborder">
          <h1>Strategy</h1>
          </td>
          <td className="noborder">
          <div className={messageClassName}>{globalMessage}</div>
          </td>
          </tr>
          </tbody>
          </table>          
          <div className="orderNavWrap">
            <div className="addOrderWrap">
              <SearchBar data={strategyData} handleSearchChange={handleSearchChange} dataType="strategy" status={filterOrders} />
              {/* <button
                className="addOrder"
                onClick={() => sendGlobalReload()}>
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Refresh Global</span>
              </button>                */}
              <button
                className="addOrder"
                onClick={() => sendParamReload()}>
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Refresh</span>
              </button> 
              <button className="addOrder" onClick={() => { setButtonPopup(true); setEntryLevel(); }}>
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
          <div className="orderWrap">
            {/* <StrategyTable /> */}
            {StrategyTable()}
          </div>
        </div>
      </div>

      {AddStrategy()}

      <Popup trigger={buttonTradeViewPopup} type="popup-inner-full" setTrigger={setTradeViewButtonPopup}>
      <div className="popupWrap">
        <div className="productsSummary">
          <h3 className="productSummaryLeft">Strategy Trades</h3>
        </div>

        <div className="addNewOrderWrap">
          <div className="addNewOrderForm">
          <div className="orderWrap">
            <table className="tradelogtable">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>ST</th>                  
                  <th>Symbol</th>
                  <th>CP</th>
                  <th className="alignright">QTY</th>                  
                  <th className="alignright">EntPr</th>
                  <th className="alignright">ExtPr</th>
                  <th>Entry Time</th>
                  <th>Exit Time</th> 
                  <th>Status</th>
                  <th className="alignright">Pnl</th> 
                </tr>
              </thead>
              <tbody>
              {tradeLogDetails?.map((order) => {
                  return (
                    <tr key={order.id}>
                      <td><font className="maincolor">#</font>{order.id}</td>
                      <td>{order.strategy_name}</td>                      
                      <td>{order.symbol}</td>
                      <td>{order.cp}</td>
                      <td className="alignright">{order.qty}</td>
                      <td className="alignright">{order.enp}</td>
                      <td className="alignright">{order.exp}</td>
                      <td>{order.ent.split("00")[0]}</td>
                      <td>{(order.ext==null)?'':order.ext.split("00")[0]}</td>
                      <td>{order.status}</td>                                                                                                                                                          
                      <td className="alignright">{order.pnl}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
      </Popup>      

      <Popup trigger={buttonVarsViewPopup} type="popup-inner-full" setTrigger={setVarsViewButtonPopup}>
      <div className="popupWrap">
        <div className="productsSummary">
          <h3 className="productSummaryLeft">Strategy Variables</h3>
        </div>

        <div className="addNewOrderWrap">
          <div className="addNewOrderForm">
            <div className="orderWrap">
              <div className="strategy-vars-wrapper">

                {/* Non-Changable Params */}
                <div className="strategy-section">
                  <h3 className="strategy-section-title">Non-Changable Params</h3>
                  <div className="strategy-vars-container">
                    {[
                      "id","name","indice","order_type","expiry","position_type","strike",
                      "entry_level","tracking_level","tlslx","tlsly","auto_sqoff_time","stoploss_points",
                      "target_points","risk_amount","risk_measure","positional","repeatx",
                      "repeatx_times","retry","wnt","wnt_pts"
                    ].map(
                      (key) =>
                        key in strategyVars && (
                          <div key={key} className="strategy-var-item">
                            <span className="strategy-var-key">{key.replace(/_/g, " ")}:</span>
                            <span
                              className="strategy-var-value"
                              style={{
                                color:
                                  typeof strategyVars[key] === "boolean"
                                    ? strategyVars[key]
                                      ? "#16a34a"
                                      : "#dc2626"
                                    : !isNaN(strategyVars[key])
                                    ? "#2563eb"
                                    : "#111827",
                              }}
                            >
                              {String(strategyVars[key])}
                            </span>
                          </div>
                        )
                    )}
                  </div>
                </div>

                {/* Trade Instruments */}
                <div className="strategy-section trade-instruments">
                  <h3 className="strategy-section-title">Trade Instruments</h3>
                  <div className="strategy-vars-container">
                    {[
                      "instrument_exch_name","instrument_exch_id","expiry_date",
                      "prev_instrument_exch_name","prev_instrument_exch_id",
                      "cepe","instrument_set","trade_id"
                    ].map(
                      (key) =>
                        key in strategyVars && (
                          <div key={key} className="strategy-var-item">
                            <span className="strategy-var-key">{key.replace(/_/g, " ")}:</span>
                            <span
                              className="strategy-var-value"
                              style={{
                                color:
                                  typeof strategyVars[key] === "boolean"
                                    ? strategyVars[key]
                                      ? "#16a34a"
                                      : "#dc2626"
                                    : !isNaN(strategyVars[key])
                                    ? "#2563eb"
                                    : "#111827",
                              }}
                            >
                              {String(strategyVars[key])}
                            </span>
                          </div>
                        )
                    )}
                  </div>
                </div>

                {/* Runtime Changable Params */}
                <div className="strategy-section">
                  <h3 className="strategy-section-title">Runtime Changable Params</h3>
                  <div className="strategy-vars-container">
                    {[
                      "tlsl","trailing_sl","stoploss_level","target_level","tracking_stoploss_level",
                      "tracking_target_level","wnt_active","reentry_active","lock_update",
                      "start_trading","display_data","pending_order","trade_open","senp",
                      "entry_price","exit_price","ltp","pnl","last_status","start_tracking_sl_tg",
                      "sstatus","status","stream_status","feed","broadcast","a","a1","a2","b1","b2"
                    ].map(
                      (key) =>
                        key in strategyVars && (
                          <div key={key} className="strategy-var-item">
                            <span className="strategy-var-key">{key.replace(/_/g, " ")}:</span>
                            <span
                              className="strategy-var-value"
                              style={{
                                color:
                                  key === "pnl"
                                    ? Number(strategyVars[key]) > 0
                                      ? "#16a34a"
                                      : "#dc2626"
                                    : typeof strategyVars[key] === "boolean"
                                    ? strategyVars[key]
                                      ? "#16a34a"
                                      : "#dc2626"
                                    : !isNaN(strategyVars[key])
                                    ? "#2563eb"
                                    : "#111827",
                                fontWeight: key === "pnl" ? "600" : "500",
                              }}
                            >
                              {String(strategyVars[key])}
                            </span>
                          </div>
                        )
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
      </Popup>      


      <Popup trigger={buttonViewPopup} type="popup-inner-full" setTrigger={setViewButtonPopup}>
      <div className="popupWrap">
        <div className="productsSummary">
          <h3 className="productSummaryLeft">Strategy Log</h3>
        </div>

        <div className="addNewOrderWrap">
          <div className="addNewOrderForm">
              <table className="logtable">
              <thead>
                <tr>
                <th>ST</th>
                <th>Desc</th>
                <th>Type</th>
                <th>Time</th>
                </tr>
              </thead>
              <tbody>
              {logDetails.map((logDetail, index) => (
                <tr key={index} className={logDetail.type.toLowerCase()}>
                  <td>{logDetail.strategy_name}</td><td>{logDetail.descrp}</td><td>{logDetail.type}</td><td>{logDetail.created.split(".00")[0]}</td>
                </tr>
              ))}   
              </tbody>
              </table> 
          </div>
        </div>
      </div>
    </Popup>

      <Popup trigger={buttonEditPopup} setTrigger={setEditButtonPopup}>
      <div className="popupWrap">
        <div className="productsSummary">
          <h3 className="productSummaryLeft">Edit Strategy</h3>
        </div>

        <div className="addNewOrderWrap">
          <div className="addNewOrderForm">
            <div className="orderDetails">
              <div className="input-group input-group-20">
              <label>Name</label>  
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyDetails.name}
                  onChange={(e) =>
                    setStrategyDetails({
                      ...strategyDetails,
                      name: e.target.value, 
                    })
                  }
                  required="required"
                />
                </div>
                <div className="input-group input-group-20">                                                  
                <label>Indice</label> 
                <select
                className="orderDetailsSelect"
                value={strategyDetails.indice}
                disabled={strategyDetails.status === "Running"}
                onChange={(e) => {
                  const newIndice = e.target.value;
                  const currentExpiry = strategyDetails.expiry || "";
                  let newExpiry = currentExpiry;
              
                  if (newIndice === "BANKNIFTY") {
                    // BANKNIFTY: does NOT support weekly → force monthly expiry
                    if (!currentExpiry || currentExpiry.includes("_wk")) {
                      newExpiry = "current_month";
                    }
                  } else {
                    // NIFTY / SENSEX: support weekly → use current_wk if expiry empty
                    if (!currentExpiry || currentExpiry.trim() === "") {
                      newExpiry = "current_wk";
                    }
                  }
              
                  setStrategyDetails({
                    ...strategyDetails,
                    indice:
                      (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")
                        ? strategyDetails.indice
                        : newIndice,
                    expiry:
                      (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")
                        ? strategyDetails.expiry
                        : newExpiry,
                  });
                }}
                required
              >
                <option value="NIFTY">NIFTY</option>
                <option value="BANKNIFTY">BANKNIFTY</option>
                <option value="SENSEX">SENSEX</option>
              </select>
              
              </div>
                
                <div className="input-group input-group-20">               
                  <label>Position Type</label>
                  <select  
                    className="orderDetailsSelect"
                    placeholder=""
                    value={strategyDetails.position_type}
                    onChange={(e) =>
                      [setStrategyDetails({
                        ...strategyDetails,
                        position_type: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")
                        ? strategyDetails.position_type: e.target.value,
                      })]
                    }
                    required="required"
                  >
                    <option value="buy">BUY</option>
                    <option value="sell">SELL</option>
                  </select>
                  </div>  
                  <div className="input-group input-group-20">
                  <label>AutoSqf Time</label>
                  <input
                    type="text"
                    placeholder=""
                    className="orderDetailsInput"
                    value={strategyDetails.auto_sqoff_time}
                    onChange={(e) =>
                      [setStrategyDetails({
                        ...strategyDetails,
                        auto_sqoff_time: e.target.value,
                      })]
                    }
                    required="required"
                  />
                  </div>                  
                  <div className="input-group input-group-20-last">  
                <label>Status</label> 
                <select
                  className="orderDetailsSelect"
                  placeholder="Status"
                  value={strategyDetails.sstatus}
                  onChange={(e) =>
                    setStrategyDetails({
                      ...strategyDetails,
                      sstatus: e.target.value,
                    })
                  }
                  required="required"
                >
                  <option value="0">OFF</option>
                  <option value="1">ON</option>                                                                                                                                           
                </select> 
              </div>                                  
                <div className="input-group input-group-25">                  
                <label>Order Type</label> 
                <select   
                  className="orderDetailsSelect "
                  placeholder="Order Type"
                  value={strategyDetails.order_type}
                  onChange={(e) =>
                    setStrategyDetails({
                      ...strategyDetails,
                      order_type: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE") ? strategyDetails.order_type:e.target.value,
                    })
                  }
                  required="required"
                >
                  <option value="limit_buy">LIMIT_BUY</option>
                  <option value="limit_sell">LIMIT_SELL</option>
                  <option value="trigger_buy">TRIGGER_BUY</option>
                  <option value="trigger_sell">TRIGGER_SELL</option>                    
                </select>
                </div>
                <div className="input-group input-group-33">                  
                <label>Expiry</label> 
                <select
                className="orderDetailsSelect"
                value={strategyDetails.expiry}
                onChange={(e) =>
                  setStrategyDetails({
                    ...strategyDetails,
                    expiry:
                    (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")
                        ? strategyDetails.expiry
                        : e.target.value,
                  })
                }
                required
              >
                {[
                  { value: "current_wk", label: "WEEKLY-CURRENT" },
                  { value: "next_wk", label: "WEEKLY-NEXT" },
                  { value: "far_next_wk", label: "WEEKLY-FAR NEXT" },
                  { value: "current_month", label: "MONTHLY-CURRENT" },
                  { value: "next_month", label: "MONTHLY-NEXT" },
                  { value: "far_next_month", label: "MONTHLY-FAR NEXT" },
                ]
                  .filter(
                    (opt) =>
                      strategyDetails.indice !== "BANKNIFTY" ||
                      !opt.value.includes("_wk")
                  )
                  .map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
              </select>
              
              </div>             

 
                <div className="input-group input-group-15">                
                <label>WNT Pts</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyDetails.wnt_pts}
                  onChange={(e) => 
                    [setStrategyDetails({
                      ...strategyDetails,
                      wnt_pts: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")
                        ? strategyDetails.wnt_pts
                        : e.target.value,
                    })]
                  }
                  required="required"
                />     
                </div>   
              <div className="input-group input-group-15">
                  <label>WNT</label>
                  <Switch disabled={(strategyDetails.order_type==="trigger_buy" || strategyDetails.order_type==="trigger_sell") ?setWntOff(strategyDetails):false} checked={(strategyDetails.wnt===1?true:false)} onClick={(event) => { handleWntChange(strategyDetails, event)}} />
                   
                </div>                  
                <div className="input-group input-group-10">
                  <label>Positional</label>
                  <Switch checked={(strategyDetails.positional===1?true:false)} onClick={(event) => { handleCarryChange(strategyDetails, event)}} />
                </div>                                           
                <div className="input-group input-group-20">  
                <label>Entry Level</label> 
                <input 
                  type="text"
                  placeholder="Entry Level"
                  className="orderDetailsInput"
                  value={strategyDetails.entry_level}
                  onChange={(e) => {
                    setStrategyDetails({
                      ...strategyDetails,
                      entry_level: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.entry_level:e.target.value,
                    });}
                  }
                  required="required"
                />   
                </div>
                <div className="input-group input-group-10">                
                <label>TLSLX</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyDetails.tlslx}
                  onChange={handleTLSLXEditChange}
                  // onChange={(e) => 
                  //   [setStrategyDetails({
                  //     ...strategyDetails,
                  //     tlslx: e.target.value,
                  //   })]
                  // }
                  required="required"
                />     
                </div> 
                <div className="input-group input-group-10">                
                <label>TLSLY</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyDetails.tlsly}
                  onChange={handleTLSLYEditChange}
                  // onChange={(e) => 
                  //   [setStrategyDetails({
                  //     ...strategyDetails,
                  //     tlsly: e.target.value,
                  //   })]
                  // }
                  required="required" 
                />     
                </div>                   
                <div className="input-group input-group-15">                  
                <label>Stoploss</label> 
                <input
                  type="text"
                  placeholder="Stoploss"
                  className="orderDetailsInput "
                  value={strategyDetails.stoploss}
                  onChange={(e) => {
                    setStrategyDetails({
                      ...strategyDetails,
                      stoploss: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.stoploss:e.target.value,                      
                    }); }

                  }
                  required="required"
                /> 
                </div>                
                <div className="input-group input-group-15">                      
                <label>Target</label> 
                <input
                  type="text"
                  placeholder="Target"
                  className="orderDetailsInput "
                  value={strategyDetails.target}
                  onChange={(e) =>
                    setStrategyDetails({
                      ...strategyDetails,
                      target: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.target:e.target.value,                           
                    })
                  }
                  required="required"
                />
                </div>
               
                <div className="input-group input-group-20">                                    
                <label>Strike</label> 
                <select readOnly 
                  className="orderDetailsSelect "
                  placeholder="Strike"
                  value={strategyDetails.strike}
                  onChange={(e) =>
                    setStrategyDetails({
                      ...strategyDetails,
                      strike:(strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.strike:e.target.value,
                    })
                  }
                  required="required"
                >
                  <option value="-20">OTM20</option>                     
                  <option value="-19">OTM19</option>                     
                  <option value="-18">OTM18</option>                     
                  <option value="-17">OTM17</option>                     
                  <option value="-16">OTM16</option>                     
                  <option value="-15">OTM15</option>                     
                  <option value="-14">OTM14</option>                     
                  <option value="-13">OTM13</option>                     
                  <option value="-12">OTM12</option>                     
                  <option value="-11">OTM11</option>                 
                  <option value="-10">OTM10</option>                     
                  <option value="-9">OTM9</option>  
                  <option value="-8">OTM8</option>  
                  <option value="-7">OTM7</option>  
                  <option value="-6">OTM6</option>  
                  <option value="-5">OTM5</option>                   
                  <option value="-4">OTM4</option>  
                  <option value="-3">OTM3</option>  
                  <option value="-2">OTM2</option>                                                              
                  <option value="-1">OTM1</option>                    
                  <option value="0">ATM</option>
                  <option value="1">ITM1</option>
                  <option value="2">ITM2</option>
                  <option value="3">ITM3</option>
                  <option value="4">ITM4</option> 
                  <option value="5">ITM5</option>                                        
                  <option value="6">ITM6</option>                                        
                  <option value="7">ITM7</option>                                        
                  <option value="8">ITM8</option>                                        
                  <option value="9">ITM9</option>                                        
                  <option value="10">ITM10</option>
                  <option value="11">ITM11</option>                                      
                  <option value="12">ITM12</option>                                      
                  <option value="13">ITM13</option>                                      
                  <option value="14">ITM14</option>                                      
                  <option value="15">ITM15</option>                                      
                  <option value="16">ITM16</option>                                      
                  <option value="17">ITM17</option>                                      
                  <option value="18">ITM18</option>                                      
                  <option value="19">ITM19</option>                                      
                  <option value="20">ITM20</option>                                                                             
                </select>
                </div>
                <div className="input-group input-group-5">
                  <label>ReEntry</label>
                  <Switch checked={(strategyDetails.retry===1?true:false)} onClick={(event) => { handleRetryChange(strategyDetails, event)}} />
                   
                </div>                  
                <div className="input-group input-group-15">                
                <label>SL Level</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyDetails.stoploss_level}
                  onChange={(e) => 
                    setStrategyDetails({
                      ...strategyDetails,
                      stoploss_level: e.target.value,
                    })
                  }
                  required="required"
                />     
                </div>
                <div className="input-group input-group-15">                
                <label>TLSL Level</label>
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyDetails.trailing_sl}
                  onChange={(e) => 
                    setStrategyDetails({
                      ...strategyDetails,
                      trailing_sl: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.trailing_sl:e.target.value,                         
                    })
                  }
                  required="required"
                />     
                </div>                
                <div className="input-group input-group-15">    
                <label>Target Level</label>            
                <input
                  type="text"
                  placeholder=""
                  className="orderDetailsInput"
                  value={strategyDetails.target_level}
                  onChange={(e) =>
                    setStrategyDetails({
                      ...strategyDetails,
                      target_level: e.target.value,
                    })
                  }
                  required="required"
                />                   
                </div>                 
                <div className="input-group input-group-15">                  
                <label>Qty</label> 
                <input 
                    type="text"
                    placeholder=""
                    className="orderDetailsInput "
                    value={strategyDetails.qty}
                    onChange={(e) => {
                      setStrategyDetails({
                        ...strategyDetails,
                        qty: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.qty:e.target.value,
                    
                      }); }
                    }
                    required="required"
                  />    

                </div>    
                <div className="input-group input-group-10">  
                <label>R.Amt</label>                 
                <input
                  type="text"
                  placeholder="Risk Amount"
                  className="orderDetailsInput"
                  value={strategyDetails.risk_amount}
                  onChange={(e) => {
                    setStrategyDetails({
                      ...strategyDetails,
                      risk_amount: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.risk_amount:e.target.value,
                    }); }
                  }
                  required="required"
                />
                </div>                                        
                <div className="input-group input-group-10">                  
                <label>R:R</label> 
                <input
                    type="text"
                    placeholder="Risk Reward"
                    className="orderDetailsInput "
                    value={strategyDetails.risk_reward}
                    onChange={(e) =>
                      setStrategyDetails({
                        ...strategyDetails,
                        risk_reward: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.risk_reward:e.target.value,                        
                      })
                    }
                    required="required"
                  />    

                </div>
                  <div className="input-group input-group-10">
                  <label>RepX</label>
                  <input
                    type="text"
                    placeholder="Repeat Times"
                    className="orderDetailsInput"
                    value={strategyDetails.repeatx_times}
                    onChange={(e) =>
                      [setStrategyDetails({
                        ...strategyDetails,
                        repeatx_times: (strategyDetails.status === "Running" || strategyDetails.status === "WaitingReEntry" || strategyDetails.status === "WaitingRepeat" || strategyDetails.status === "WNT_ACTIVE")?strategyDetails.repeatx_times:e.target.value,
                      })]
                    }
                    required="required"
                  />                    
                </div>                
                <div className="input-group input-group-5">
                  <label>Repeat</label>
                  <Switch checked={(strategyDetails.repeatx===1?true:false)} onClick={(event) => { handleRepeatChange(strategyDetails, event)}} />
                   
                </div>                 
              
               

            </div>
          </div>
        </div>
        <div>
        {warningMessage && (
        <p style={{ color: "red", fontSize: "0.9em", textAlign: "center" }}>{warningMessage}</p>
        )}          
        </div>
        <div className="submitWrap">
          <div className="submitNewOrder">
              <div className="input-group input-group-33">  
              <button
                className="calculateBtn"
                onClick={(e) => CalcParamsAll()}>
                <CalculateIcon />               
                <span className="addOrderText">Calculate</span>
              </button>   
              </div> 
              <div className="input-group input-group-33">  
              <button
                className="calculateBtn"
                onClick={(e) => ResetLevels()}>
                <CalculateIcon />               
                <span className="addOrderText">Reset Levels</span>
              </button>   
              </div>                             
              <div className="input-group input-group-33">                       
              <button
                className="submitNewOrderBtn"
                disabled={updateDisabled}
                onClick={() => {
                  ResetLevels();
                  CalcParamsAll();
                  UpdateStrategy();
                }}>
                <EditRoundedIcon />
                <span className="addOrderText">Update</span>
              </button>
              </div>                        
          </div>
        </div>
      </div>
    </Popup>
      <div>
        <ToastContainer /> 
      </div>
    </div>
  );
}

export default Strategy;
